import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import NormalToggle from 'v-c/Forms/Toggles/NormalToggle';
import { TableRow, DataCell, TextCell } from 'v-c/TableView';
import Spinner from '../LoadingIndicator/Spinner';

// TODO: this component doesn't use the static ui lib
export default function ReportsListItem({
    attemptToEditReport,
    index,
    getReportsMessage,
    report,
    onToggle,
}) {
    const { enabled, id, name, description, statusIsUpdating, type } = report;

    return (
        <TableRow rowId={`${index}`} index={index} data-row={id}>
            <TextCell data-item="name" cellId="name">
                {name}
            </TextCell>
            <TextCell data-item="description" cellId="description" style={{ width: '100%' }}>
                {description}
            </TextCell>
            <DataCell style={{ textAlign: 'center' }} cellId="status">
                {statusIsUpdating && (
                    <div style={{ position: 'relative', top: '-9px' }}>
                        <Spinner />
                    </div>
                )}
                {!statusIsUpdating && <NormalToggle isChecked={enabled} onToggle={onToggle} />}
            </DataCell>
            <TextCell cellId="edit">
                <a data-link="report-edit" role="presentation" onClick={attemptToEditReport(id, type)}>
                    {getReportsMessage('table.row.edit')}
                </a>
            </TextCell>
        </TableRow>
    );
}

ReportsListItem.displayName = displayName('Reports/ReportsListItem');

ReportsListItem.propTypes = {
    index: PropTypes.number.isRequired,
    attemptToEditReport: PropTypes.func.isRequired,
    getReportsMessage: PropTypes.func.isRequired,
    report: PropTypes.object.isRequired,
    onToggle: PropTypes.func.isRequired,
};
